import React, { useEffect, useState } from 'react';
import { BsExclamationCircle, BsCheckCircle, BsBuilding  } from 'react-icons/bs';
import { FiMonitor, FiUser } from 'react-icons/fi';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { FaClipboardList } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import 'tippy.js/dist/tippy.css';
import tippy from 'tippy.js';
import moment from 'moment';

import { ScheduleService } from '../../services/methods/ScheduleService';

import { useSchedule } from '../../hooks/schedules';
import { useUser } from '../../hooks/user';
import { useAuth } from '../../hooks/auth';

import { OutgoingOSModal } from '../../components/OutgoingOsModal';
import { LaunchOSModal } from '../../components/LaunchOSModal';
import SideMenu from '../../components/SideMenu';
import Header from '../../components/Header';

import FullCalendar, { } from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from '@fullcalendar/timegrid';

import { pickTextColorBasedOnBgColorSimple } from '../../utils/getFontDarkOrLight';

import { styleSheet } from '../../assets/styles/global';

import {
  Container, MainBody, CalendarContainer, Calendar, Load,
  Tips, TipGroup, Text, Receive,
  SelectAnalystContainer, Overlay, SelectAnalystContent, AnalystContainer,
  AnalystName,
  Checkbox,
  Checkmark,
  DetailContainer,
  Detail,
  DetailText,
  Tip,
  Title
} from './styles';

const Schedule: React.FC = () => {
  const scheduleService: ScheduleService = new ScheduleService();

  const [showMoney, setShowMoney] = useState(false)
  const [modalSelectAnalyst, setModalSelectAnalyst] = useState(false)
  const [receiveValue, setReceiveValue] = useState(0);
  const [workedHours, setWorkedHours] = useState(0);
  const [receiveValueLoad, setReceiveValueLoad] = useState(false);
  const { userIsLogged } = useAuth()
  const { userInfo } = useUser()

  const {
    month,
    year,
    calendarHeight,
    isOpenLaunchOSModal,
    isOpenOutgoingOSModal,
    launchOsModalData,
    fullCalendarData,
    currentDate,
    isLoading,
    handleEventClick,
    renderEventContent,
    loadSchedulesData,
    handleCloseLaunchOSModal,
    handleCloseOutgoingOSModal,
    setMonth,
    setYear,
    filterSchedules,
    filter,
    setFilter,
    schedules,
    receiveIsUpdate,
    setReceiveIsUpdate,
    handleFetchAnalyst,
    fetchAnalystLoad,
    analistas,
    setAnalyst,
    analyst,
    coordinators
  } = useSchedule()

  const history = useHistory()

  const handleLogout = async () => {
    await localStorage.removeItem('ethosxAnalista:token')
    await sessionStorage.removeItem('analystName')
    await sessionStorage.removeItem('token')

    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach(name => {
          caches.delete(name);
        })
      });
    }

    history.push('/login')
    window.location.reload();

  }

  async function handleGetReceiveValue(month: number, year: number) {
    try {
      setReceiveValueLoad(true);
      const userToken = await sessionStorage.getItem('token') || await localStorage.getItem('ethosxAnalista:token')
      const { data, status } = await scheduleService.getReceiveValue(userToken, month, year)
      
      if(status === 200) {
        setReceiveValue(data.receber)
        setWorkedHours(data.horas);
      }
      
    } catch (error: any) {
      if (error.response) {
        toast.error(error.response.data.errorMessage)
      }
    } finally {
      setReceiveValueLoad(false);
    }
  }

  useEffect(() => {
    // if (Number(moment().format('DD')) > 25) {
    //   loadSchedulesData(Number(moment().add(1, 'month').format('MM')))
    //   setMonth(Number(moment().add(1, 'month').format('MM')))
    // } else {
    //   loadSchedulesData(month)
    // }
    loadSchedulesData(month, year)
    setReceiveIsUpdate(false)
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!userIsLogged()) {
      history.push('/login')
    }
    // eslint-disable-next-line
  }, [])


  return (
    <>
      <Container>
        <SideMenu currentMenu="calendario" />

        {
          isLoading ? <Load><Loader active inline='centered'>Carregando</Loader></Load>
            :
            <MainBody>
              <Header screen="Calendário" logout={handleLogout} />

              <CalendarContainer>
                <Calendar>
                  <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    headerToolbar={{
                      left: userInfo.cargo === 'C' ? 'prev,next today myCustomButton' : 'prev,next today',
                      center: 'customTitle',
                      right: ''//'dayGridMonth,timeGridWeek,timeGridDay'
                    }}
                    views={{
                      dayGridMonth: {
                        type: "month",
                        duration: { week: moment(currentDate).isoWeekday() >= 6 ? 6 : 6  },
                        buttonText: "5 Weeks",
                        fixedWeekCount : false                     
                      }
                    }}
                    stickyHeaderDates={false}
                    initialView='dayGridMonth'
                    editable={false}//true
                    selectable={true}
                    selectMirror={true}
                    firstDay={1}
                    // dayMaxEvents={true}
                    customButtons={userInfo.cargo === 'C' ? {
                      myCustomButton: {
                        text: analistas.find(analista => analista.codigo === analyst) ? analistas.find(analista => analista.codigo === analyst)!.nome : 'Selecionar Analista',
                        click: async function () {
                          setModalSelectAnalyst(true)
                          await handleFetchAnalyst()
                        }
                      },
                      prev: {
                        text: 'Prev',
                        click: async function () {
                          if (month === 1) {
                            setMonth(12)
                            setYear(year -1)
                            await loadSchedulesData(12, year - 1)
                            handleGetReceiveValue(12, year - 1)
                          } else {
                            setMonth(month - 1)
                            await loadSchedulesData(month - 1, year)
                            handleGetReceiveValue(month - 1, year)
                          }
                          setFilter('')
                        }
                      },
                      next: {
                        text: 'Next',
                        click: async function () {
                          if (month === 12) {
                            setMonth(1)
                            setYear(year + 1)
                            await loadSchedulesData(1, year + 1)
                            handleGetReceiveValue(1, year + 1)
                          } else {
                            setMonth(month + 1)
                            await loadSchedulesData(month + 1, year)
                            handleGetReceiveValue(month + 1, year)
                          }
                          setFilter('')
                        }
                      },
                      today: {
                        text: 'Hoje',
                        click: async function () {
                          const month = Number(moment().format('DD')) > 25 ?  Number(moment().format('MM')) + 1 > 12 ? 1 : (Number(moment().format('MM')) + 1) : Number(moment().format('MM'))
                          const year = Number(moment().format('DD')) > 25 && Number(moment().format('MM')) + 1 > 12 ? Number(moment().format('YYYY')) + 1 : Number(moment().format('YYYY'))
                          setMonth(Number(month))
                          setYear(year)
                          await loadSchedulesData(Number(month), year)
                          handleGetReceiveValue(Number(month), year)
                          setFilter('')
                        }
                      },
                      customTitle: {
                        text: `Período de ${new Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(new Date(moment(currentDate).add(1, 'month').format()))}`,
                        click: (ev) => {
                          ev.preventDefault()
                        },
                      }
                    } : {
                      prev: {
                        text: 'Prev',
                        click: async function () {
                          if (month === 1) {
                            setMonth(12)
                            setYear(year - 1)
                            await loadSchedulesData(12, year - 1)
                            handleGetReceiveValue(12, year - 1)
                          } else {
                            setMonth(month - 1)
                            await loadSchedulesData(month - 1, year)
                            handleGetReceiveValue(month - 1, year)
                          }
                          setFilter('')
                        }
                      },
                      next: {
                        text: 'Next',
                        click: async function () {
                          if (month === 12) {
                            setMonth(1)
                            setYear(year + 1)
                            await loadSchedulesData(1, year + 1)
                            handleGetReceiveValue(1, year + 1)
                          } else {
                            setMonth(month + 1)
                            await loadSchedulesData(month + 1, year)
                            handleGetReceiveValue(month + 1, year)
                          }
                          setFilter('')
                        }
                      },
                      today: {
                        text: 'Hoje',
                        click: async function () {
                          const month = Number(moment().format('DD')) > 25 ?  Number(moment().format('MM')) + 1 > 12 ? 1 : (Number(moment().format('MM')) + 1) : Number(moment().format('MM'))
                          const year = Number(moment().format('DD')) > 25 && Number(moment().format('MM')) + 1 > 12 ? Number(moment().format('YYYY')) + 1 : Number(moment().format('YYYY'))
                          setMonth(Number(month))
                          setYear(year)
                          await loadSchedulesData(Number(month), year)
                          handleGetReceiveValue(Number(month), year)
                          setFilter('')
                        }
                      },
                      customTitle: {
                        text: `Período de ${new Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(new Date(moment(currentDate).add(1, 'month').format()))}`,
                        click: (ev) => {
                          ev.preventDefault()
                        },
                      }
                    }}
                    weekends={true}
                    events={fullCalendarData}
                    initialDate={currentDate}
                    visibleRange={{
                      start: currentDate,
                      end: moment(currentDate).add(1, 'month').subtract(1, 'day').format('YYYY-MM-DD')
                    }}
                    // select={handleDateSelect}
                    eventContent={renderEventContent}
                    eventClick={handleEventClick}
                    eventMouseEnter={(arg) => tippy(arg.el, { content: `Projeto: ${arg.event.extendedProps.codpro} - ${arg.event.extendedProps.projeto}  <br>Cliente: ${arg.event.extendedProps.codcli} - ${arg.event.extendedProps.nomecli} <br>Coordenador: ${arg.event.extendedProps.nomeCoordenador}`, theme: 'material', allowHTML: true })}
                    // eventsSet={this.handleEvents}
                    height="auto"//{calendarHeight - 100}//715
                    contentHeight={calendarHeight - 100}
                    dragScroll={true}
                    expandRows={true}
                    locale='pt'
                    moreLinkContent={function (args) {
                      return '+' + args.num + ' Agendas';
                    }}
                    dayCellClassNames={function (args) {
                      const startDate = moment(currentDate).format('YYYY-MM-DD')
                      const finalDate = moment(startDate).add(1, 'month').add(1, 'day').format('YYYY-MM-DD')
                      if(moment(args.date).isBetween(startDate, finalDate)){
                        return 'inPeriod'
                      }else{
                        return 'notInPeriod'
                      }
                    }}
                  />
                </Calendar>
                <Tips>
                  <Title>Filtros</Title>
                  <TipGroup
                    onClick={() => filterSchedules('abertas', schedules)}
                    isSelected={filter === 'abertas'}
                  >
                    <Tip>
                      <BsExclamationCircle color={styleSheet.error} size={16} />
                      <Text>{schedules.filter(item => item.os === '').length} Aberta{schedules.filter(item => item.os !== '').length > 1 && 's'}</Text>
                    </Tip>

                    <Checkbox>
                      <Checkmark checked={filter === 'abertas'} />
                    </Checkbox>
                  </TipGroup>

                  <TipGroup
                    onClick={() => filterSchedules('apontadas', schedules)}
                    isSelected={filter === 'apontadas'}
                  >
                    <Tip>
                      <BsCheckCircle color={styleSheet.success} size={16} />
                      <Text>{schedules.filter(item => item.os !== '').length} Lançada{schedules.filter(item => item.os !== '').length > 1 && 's'}</Text>
                    </Tip>
                    <Checkbox>
                      <Checkmark checked={filter === 'apontadas'} />
                    </Checkbox>
                  </TipGroup>

                  <TipGroup
                    onClick={() => filterSchedules('remoto', schedules)}
                    isSelected={filter === 'remoto'}

                  >
                  
                    <Tip>
                      <FiMonitor color={styleSheet.info}  size={16} />
                      <Text>Remoto</Text>
                    </Tip>

                    <Checkbox>
                      <Checkmark  checked={filter === 'remoto'} />
                    </Checkbox>
                  </TipGroup>

                  <TipGroup
                    onClick={() => filterSchedules('presencial', schedules)}
                    isSelected={filter === 'presencial'}
                  > 
                    <Tip>
                      <BsBuilding color={styleSheet.warning} size={16} />
                      <Text>Presencial</Text>
                    </Tip>

                    <Checkbox>
                      <Checkmark checked={filter === 'presencial'} />
                    </Checkbox>
                  </TipGroup>

                  <TipGroup
                    onClick={() => filterSchedules('', schedules)}
                    isSelected={filter === ''}
                  >
                    <Tip>
                      <FaClipboardList size={16} />
                      <Text>Todas</Text>
                    </Tip>

                    <Checkbox>
                      <Checkmark checked={filter === ''} />
                    </Checkbox>
                  </TipGroup>
                  {
                    userInfo.cargo !== "C" && userInfo.tipo !== "P" &&                
                    <Receive>
                      <Title>Informação</Title>
                      {
                        receiveIsUpdate ? (
                          showMoney 
                            ? 
                            <DetailContainer>
                              <Detail>
                                {
                                  receiveValueLoad ? <Loader active inline='centered'></Loader> :  
                                  <>
                                    <DetailText>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(receiveValue)}</DetailText>
                                    <DetailText>horas {workedHours}</DetailText> 
                                  </>
                                }
                              </Detail> 
                              <FiEyeOff onClick={() => setShowMoney(false)} />
                            </DetailContainer> 
                            : 
                            <DetailContainer>
                              ***** 
                              <FiEye 
                                onClick={() => {
                                  setShowMoney(true)
                                  handleGetReceiveValue(month, year)
                                }} 
                              />
                            </DetailContainer>
                        ) : (
                          <TipGroup
                            onClick={() => {
                              filterSchedules('', schedules)
                              loadSchedulesData(month, year)
                              handleGetReceiveValue(month, year)
                            }}
                            isSelected={!receiveIsUpdate}
                          >
                            <Text>Clique aqui para atualizar o valor</Text>
                          </TipGroup>
                        )
                      }
                    </Receive>
                  }

                  <Receive>
                    <Title>Legendas</Title>
                    {
                      coordinators.map(coordinator => {
                        if(coordinator.nome !== '') {
                          return (
                            <TipGroup
                              onClick={() => console.log()}
                              isSelected={true}
                            > 
                            <Tip>
                              <FiUser color={coordinator.color} size={16} />
                              <Text>{coordinator.nome}</Text>
                            </Tip>
                            </TipGroup>
                          )
                        }
                        
                      })
                    }
                  </Receive>
                </Tips>

                {
                  modalSelectAnalyst &&
                  <>
                    <Overlay onClick={() => setModalSelectAnalyst(false)} />
                    <SelectAnalystContainer>
                      <SelectAnalystContent>
                        {
                          fetchAnalystLoad ?
                            <Load><Loader active inline='centered'>Carregando</Loader></Load>
                            :

                            analistas.map(analyst => (
                              <AnalystContainer onClick={async () => {
                                await setAnalyst(analyst.codigo)
                                setModalSelectAnalyst(false)
                                await loadSchedulesData(month, year, analyst.codigo)
                              }} color={analyst.color === '' ? '#cccccc' : analyst.color}>
                                <AnalystName style={{ color: pickTextColorBasedOnBgColorSimple(analyst.color) }} >{analyst.nome}</AnalystName>
                              </AnalystContainer>
                            ))
                        }
                      </SelectAnalystContent>
                    </SelectAnalystContainer>
                  </>
                }
              </CalendarContainer>
            </MainBody>
        }
      </Container>
      
      { isOpenLaunchOSModal && <LaunchOSModal visible={isOpenLaunchOSModal} data={launchOsModalData} closeModal={handleCloseLaunchOSModal} /> } 

      {
        isOpenOutgoingOSModal && <OutgoingOSModal visible={isOpenOutgoingOSModal} data={launchOsModalData} closeModal={handleCloseOutgoingOSModal} />
      }
    </>
  );
}

export default Schedule;